import { SharedState } from 'app/types-shared';

export const getSubscriberGroupAdminAccess =
  (sharedState: SharedState): boolean => sharedState?.access?.adminPanel?.subscriberGroup?.administrationCentral;
